import React from 'react';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';

import ModalPortal from '../../../../components/modal-portal';
import { MoveInventoryModal } from '../../../../products/product-details/components/tabs/inventory/modals/move-inventory';
import { useInventoryModalData } from '../../../../products/product-details/hooks/use-inventory-modal-data';

/**
 * Standalone container for MoveInventoryModal that fetches all required data.
 * Use this when opening the move modal outside of ProductDetailsContext.
 * @param {object} props
 * @param {string} props.productId
 * @param {string} props.productName
 * @param {string} props.productSku
 * @param {() => void} props.onClose
 * @param {string} [props.inventoryWarehouseId] - Optional: warehouse ID from URL when user clicked move button
 * @param {string} [props.lotUuid] - Optional: lot UUID for lot-tracked products
 * @param {string} [props.thumbnailUrl] - Optional: product image URL
 * @returns {JSX.Element}
 */
export const MoveInventoryModalContainer = ({
  productId,
  productName,
  productSku,
  onClose,
  inventoryWarehouseId,
  lotUuid,
  thumbnailUrl,
}) => {
  const { isLoading, inventoryWarehouses, inventoryWarehouseLocations, productInventoryByLocation, reload } =
    useInventoryModalData(productId);

  if (isLoading) {
    return (
      <ModalPortal onClose={onClose}>
        <Modal size='medium'>
          <ModalBody>
            <LoadingIndicator />
          </ModalBody>
        </Modal>
      </ModalPortal>
    );
  }

  return (
    <ModalPortal onClose={onClose}>
      <MoveInventoryModal
        inventoryWarehouseId={inventoryWarehouseId}
        inventoryWarehouseLocations={inventoryWarehouseLocations}
        inventoryWarehouses={inventoryWarehouses}
        lotUuid={lotUuid}
        onClose={onClose}
        onReloadLocations={reload}
        productId={productId}
        productInventoryByLocation={productInventoryByLocation}
        productName={productName}
        productSku={productSku}
        thumbnailUrl={thumbnailUrl}
      />
    </ModalPortal>
  );
};
